import React, { createContext, useContext, useReducer } from 'react';
import find from 'lodash-es/find';
import PropTypes from 'prop-types';

const initialState = {
  siteNotifications: [],
  headerNotification: null,
  bannerNotification: null,
};

export const SiteNotificationStore = ({ children }) => {
  const [state, dispatch] = useReducer(SiteNotificationReducer, initialState);
  return (
    <SiteNotificationContext.Provider value={[state, dispatch]}>
      {children}
    </SiteNotificationContext.Provider>
  );
};

SiteNotificationStore.propTypes = {
  children: PropTypes.any,
};

export const SiteNotificationContext = createContext(initialState);

export const useSiteNotfication = () => {
  const [state, dispatch] = useContext(SiteNotificationContext);
  const setSiteNotifications = siteNotifications => {
    dispatch({ type: 'SET_SITE_NOTIFICATIONS', payload: siteNotifications });
  };
  return {
    ...state,
    setSiteNotifications,
  };
};

export const SiteNotificationReducer = (state, action) => {
  switch (action.type) {
    case 'SET_SITE_NOTIFICATIONS':
      return {
        ...state,
        siteNotifications: action.payload,
        headerNotification: find(action.payload, ['uiPath', '/:header']),
        bannerNotification: find(action.payload, ['uiPath', '/:banner']),
      };
    default:
      return state;
  }
};
